var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWfgpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#36384A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.2496L39.4 16.5996L26.1 29.8996L17.55 25.1496L16.125 23.2496Z",
    fill: "#F5F3F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.2496L39.4 16.5996L26.1 29.8996L17.55 25.1496L16.125 23.2496Z",
    fill: "url(#pattern0_18110_63319)",
    fillOpacity: 0.03
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7519 39.8748L38.928 17.55L26.1038 29.8999L30.8538 38.4499L32.7519 39.8748Z",
    fill: "#F5F3F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7519 39.8748L38.928 17.55L26.1038 29.8999L30.8538 38.4499L32.7519 39.8748Z",
    fill: "url(#pattern1_18110_63319)",
    fillOpacity: 0.03
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3992 16.5996L33.3407 39.1026C33.1214 39.9174 32.0279 40.0631 31.6028 39.3343L26.0992 29.8996M39.3992 16.5996L26.0992 29.8996M39.3992 16.5996L16.8962 22.6581C16.0815 22.8775 15.9357 23.9709 16.6645 24.396L26.0992 29.8996",
    stroke: "#F5F3F2",
    strokeWidth: 1.425,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3992 16.5996L33.3407 39.1026C33.1214 39.9174 32.0279 40.0631 31.6028 39.3343L26.0992 29.8996M39.3992 16.5996L26.0992 29.8996M39.3992 16.5996L16.8962 22.6581C16.0815 22.8775 15.9357 23.9709 16.6645 24.396L26.0992 29.8996",
    stroke: "url(#pattern2_18110_63319)",
    strokeOpacity: 0.03,
    strokeWidth: 1.425,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0301 27.9687L37.1741 18.8247C37.3835 18.6154 37.7337 18.8245 37.6486 19.1081L32.9204 34.8689C32.6789 35.6738 31.5881 35.7918 31.18 35.0572L27.8714 29.1018C27.6655 28.731 27.7302 28.2686 28.0301 27.9687Z",
    fill: "#BBBECF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_18110_63319",
    patternContentUnits: "objectBoundingBox",
    width: 0.10449,
    height: 0.182857
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18110_63319",
    transform: "scale(0.00163265 0.00285714)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_18110_63319",
    patternContentUnits: "objectBoundingBox",
    width: 0.10971,
    height: 0.185343
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18110_63319",
    transform: "scale(0.00171422 0.00289598)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_18110_63319",
    patternContentUnits: "objectBoundingBox",
    width: 0.0984615,
    height: 0.0984615
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18110_63319",
    transform: "scale(0.00153846)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18110_63319",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAONJREFUeF7t20EOhEAIRFG4/6F7DvEnYeFzryQIv6pBd2behOu9dPvsbog+k+NLgArQAqmJcw9iAAhSgZKB3IJkkAySQTJ4CiE+gA8oBeg0mH3Ai084P89HhqwEqIA209ICsQdjAeaZIgaAYKxBDMCAYy8fXwAIgiAIcoJpJEYGI4VjB3YrbC9gL2AvkCB43cM5PgZgAAZgQFnNZAhdGykQBEEQBEEQDBmgAm2glM/z+QUYisYUGoldO7kY32IEAzCg6RgIRgjFAsw+AgRBMNYgBmCAT2TCYfoPPz/HCqQCX1eBHzHnv7C7WhBSAAAAAElFTkSuQmCC"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfgpsIcon);
export default __webpack_public_path__ + "static/media/wfgpsIcon.8de7a2649582d407b5d8ec0c06e808ea.svg";
export { ForwardRef as ReactComponent };